import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  public formGroup: FormGroup = new FormGroup({});
  public req: any;
  public waitLogin = false;
  public loginPage = '';
  constructor(private formBuilder: FormBuilder,
              private router: Router,
              public helpersService: HelpersService,
              private dataService: DataService) {

  }

  ngOnInit(): void {
    console.log();
    this.createForm(); 
  }

  private createForm(): void {
    this.req = {};
    // this.req.username = 'service.tutor1@luiss.it';
    // this.req.password = 'auw7gT91?';
    this.formGroup = this.formBuilder.group({
      username: this.formBuilder.control(this.req.username, [
        Validators.required
      ]),
      password: this.formBuilder.control(this.req.password, [
        Validators.required,
        Validators.minLength(3)
      ])
    });
  }

  public login(): void {
    if (this.req.username && this.req.password) {
      this.req.username = this.req.username.trim();
      this.req.password = this.req.password.trim();
      this.waitLogin = true;
      this.dataService.login(this.req).subscribe((response: any) => {
        this.helpersService.setIsLogged(true);
        this.helpersService.setCredentials(this.req);
        this.helpersService.setUser(response);
        this.helpersService.routeInit();
        this.waitLogin = false;
      }, (err: any) => {
          this.helpersService.setCredentials(null);
          this.helpersService.setIsLogged(false);
          this.waitLogin = false;
          this.helpersService.showError('Username o password errate!');
      });
    }
  }

  public loginAdfs(): void {
    window.open(`${environment.urlApi}/adfs/saml/authentication?application=attendances-report`, '_self');
  }
}
